export const footerItems = {
  solutions: [
    {
      name: 'footer.category1.list1.name',
      list: [
        {
          name: 'footer.category1.list1.list1.name1',
          href: '/solutions/video-stream-china/'
        },
        {
          name: 'footer.category1.list1.list1.name2',
          href: '/solutions/ott-streaming/'
        }
      ]
    },
    {
      name: 'footer.category1.list2.name',
      list: [
        {
          name: 'footer.category1.list2.list1.name1',
          href: '/features/china-access/'
        }
      ]
    },
    {
      name: 'footer.category1.list3.name',
      href: '/features/power-ups/'
    },
    {
      name: 'footer.category1.list4.name',
      href: '/features/enterprise-support/'
    }
  ],
  resources: [
    {
      name: 'footer.category5.name',
      href: 'https://hubble.mlytics.com/',
      target: '_blank',
      rel: 'noopener noreferrer',
      list: [
        {
          name: 'footer.category5.list1.name1',
          href: 'https://hubble.mlytics.com/basic_test',
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        {
          name: 'footer.category5.list1.name2',
          href: 'https://hubble.mlytics.com/cdn_comparison',
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        {
          name: 'footer.category5.list1.name3',
          href: 'https://hubble.mlytics.com/site_cdn_comparison',
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        {
          name: 'footer.category5.list1.name4',
          href: 'https://hubble.mlytics.com/site_mlytics_comparison',
          target: '_blank',
          rel: 'noopener noreferrer'
        }
      ]
    },
    {
      name: 'footer.category3.list1.name1',
      href: 'https://www.mlytics.com/blog/'
    },
    {
      name: 'footer.category3.list1.name2',
      href: 'https://help.mlytics.com/',
      target: '_blank',
      rel: 'noopener noreferrer'
    },
    {
      name: 'footer.category3.list1.name3',
      href: 'https://learning.mlytics.com/',
      target: '_blank',
      rel: 'noopener noreferrer'
    },
    {
      name: 'footer.category3.list1.name5',
      href: '/about'
    },
    {
      name: 'footer.category3.list1.name6',
      href: '/careers/'
    },
    {
      name: 'footer.category3.list1.name7',
      href: 'https://www.mlytics.com/press-center/'
    },
    {
      name: 'footer.category3.list1.name8',
      href: '/press-resources/'
    },
    {
      name: 'footer.category3.list1.name9',
      href: '/terms/'
    },
    {
      name: 'footer.category3.list1.name10',
      href: '/privacy/'
    },
    {
      name: 'footer.category3.list1.name11',
      href: '/law-enforcement/'
    }
  ],
  pricing: [
    {
      name: 'footer.category4.list1.name1',
      href: '/pricing/'
    },
    {
      name: 'footer.category4.list1.name2',
      href: '/pricing/?tab=web'
    }
  ]
}
export const productItems = {
  stream: {
    name: 'footer.category2.list1.name',
    list: [
      {
        name: 'navigation.category2.header.column1',
        list: [
          {
            name: 'footer.category2.list1.list1.name4',
            href: '/video-stream/video-streaming-analytics-solution/'
          }
        ]
      },
      {
        name: 'navigation.category2.header.column2',
        list: [
          {
            name: 'footer.category2.list1.list1.name2',
            href: '/video-stream/instream-switching/'
          }
        ]
      },
      {
        name: 'navigation.category2.header.column3',
        list: [
          {
            name: 'footer.category2.list1.list1.name1',
            href: '/video-stream/multi-cdn-management/'
          },
          {
            name: 'footer.category2.list1.list1.name3',
            href: '/video-stream/hybrid-cdn-p2p/'
          },
          {
            name: 'footer.category2.list1.list1.name5',
            href: '/video-stream/low-latency-live-streaming/'
          }
          // {
          //   name: 'footer.category1.list1.list1.name1',
          //   href: '/solutions/video-stream-china/'
          // }
        ]
      },
      {
        name: 'navigation.category2.header.column5',
        list: [
          {
            name: 'footer.category2.list1.list1.name6',
            href: '#'
          }
        ]
      }
    ]
  },
  application: {
    name: 'footer.category2.list2.name',
    list: [
      {
        name: 'navigation.category2.header.column1',
        list: [
          {
            name: 'footer.category2.list2.list1.list1.name2',
            href: '/features/real-user-monitoring/'
          },
          {
            name: 'footer.category2.list2.list1.list1.name3',
            href: '/features/synthetic-monitoring/'
          },
          {
            name: 'footer.category2.list2.list1.list1.name1',
            href: '/features/pulse/'
          }
        ]
      },
      {
        name: 'navigation.category2.header.column2',
        list: [
          {
            name: 'footer.category2.list2.list2.list1.name2',
            href: '/features/smart-load-balancing/'
          },
          {
            name: 'footer.category2.list2.list2.list1.name1',
            href: '/features/dns/'
          },
          {
            name: 'footer.category2.list2.list2.list1.name3',
            href: '/features/routing-policy/'
          }
        ]
      },
      {
        name: 'navigation.category2.header.column3',
        list: [
          {
            name: 'footer.category2.list2.list3.list1.name1',
            href: '/features/multi-cdn/'
          },
          {
            name: 'footer.category2.list2.list3.list1.name2',
            href: 'https://www.mlytics.com/features/power-ups/'
          },
          {
            name: 'footer.category2.list2.list3.list1.name3',
            href: 'https://www.mlytics.com/features/china-access/'
          }
        ]
      },
      {
        name: 'navigation.category2.header.column4',
        list: [
          {
            name: 'footer.category2.list2.list4.list1.name2',
            href: '/features/origin-shield/'
          },
          {
            name: 'footer.category2.list2.list4.list1.name1',
            href: '/features/web-application-firewall/'
          },
          {
            name: 'footer.category2.list2.list4.list1.name3',
            href: '/features/api-protection/'
          },
          {
            name: 'footer.category2.list2.list4.list1.name7',
            href: '/features/bot-management/'
          },
          {
            name: 'footer.category2.list2.list4.list1.name4',
            href: '/features/ddos-protection/'
          }
        ]
      }
    ]
  }
}
export const widgetItems = [
  {
    href: 'https://www.linkedin.com/company/mlytics/',
    src: 'https://www.mlytics.com/wp-content/uploads/2022/09/LinkedIn-circle.png',
    alt: 'linkedIn'
  },
  {
    href: 'https://www.facebook.com/mlytics/',
    src: 'https://www.mlytics.com/wp-content/uploads/2022/09/facebook-circle.png',
    alt: 'Facebook'
  },
  {
    href: 'https://twitter.com/mlyticsHQ',
    src: 'https://www.mlytics.com/wp-content/uploads/2022/09/twitter-circle.png',
    alt: 'Twitter'
  },
  {
    href: 'https://www.g2.com/products/mlytics/reviews',
    src: 'https://www.mlytics.com/wp-content/uploads/2022/09/g2-circle.png',
    alt: 'G2'
  },
  {
    href: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzk0MzcwNzk2Mw==',
    src: 'https://www.mlytics.com/wp-content/uploads/2024/06/wechat-circle.png',
    alt: 'WeChat'
  }
]
